<template>
    <div class="page">
        <div class="page-header">
            <el-button @click="jumpToPage('moduleAddEdit')" type="primary" size="medium">添加信息板块</el-button>
        </div>
        <div class="page-main">
            <ul class="module-list" :style="{height: `${containerHeight}px`}">
                <li class="module-item" v-for="(moduleItem, index) in moduleList">
                    <div class="module-item__pic" :style="{backgroundImage: `url(${moduleItem.logoUrl})`}"></div>
                    <div class="module-item__info">
                        <el-tooltip class="item" effect="dark" :content="moduleItem.name" placement="top">
                            <div class="module-item__name">{{moduleItem.name}}</div>
                        </el-tooltip>
                        <div class="module-item__count">
                            <el-switch
                                v-model="moduleItem.state"
                                :active-value="1"
                                :inactive-value="2"
                                active-text="启用"
                                inactive-text="禁用"
                                @change="moduleStateChange(moduleItem)"
                            >
                            </el-switch>
                        </div>
                    </div>

                    <i class="fa fa-close" @click.stop="deleteFunc(moduleItem)"></i>
                    <i class="fa fa-edit" @click.stop="jumpToPage('moduleAddEdit', {id: moduleItem.id})"></i>
                </li>
            </ul>
            <div class="links-container">
                <p>
                    网站链接：<span>{{webUrl}}</span>
                </p>
                <p>
                    公众号链接：<span>{{mobileUrl}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js';
    import {mapGetters} from 'vuex';

    import {
        getTrainTypeListBySchoolId,
        delTrainType,
        updateTrainTypeState
    } from '@/api/setting/setting';

    export default {
        name: "moduleSetting",
        data() {
            return {
                moduleList: [],
                webUrl: '',
                mobileUrl: '',
                containerHeight: 0
            }
        },
        mounted() {
            this.getTrainTypeListBySchoolIdFunc();

            this.containerHeight = window.innerHeight - 390;

            const baseHref = this.basePath.indexOf('test') !== -1 ? 'https://test.weixiaojia.cn/mobile/#/' : 'https://m.www.weixiaojia.cn/mobile/#/';

            this.mobileUrl = `${baseHref}heartsOfRiver/outerMessageAdd?schoolId=${this.schoolInfo.id}`;
            this.webUrl = this.basePath.indexOf('test') !== -1 ? `http://testjbxez.zhxiaoyuan.cn/#/outer/messageAdd?schoolId=${this.schoolInfo.id}` : `http://jbxez.zhxiaoyuan.cn/#/outer/messageAdd?schoolId=${this.schoolInfo.id}`;
        },
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['schoolInfo'])
        },
        methods: {
            // 获取列表
            getTrainTypeListBySchoolIdFunc() {
                getTrainTypeListBySchoolId()
                    .then(res => res.data)
                    .then(data => {
                        this.moduleList = data.data;
                    })
            },
            // 删除板块
            deleteFunc(item) {
                this.$confirm('是否删除?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delTrainType({
                        typeId: item.id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                                this.getTrainTypeListBySchoolIdFunc();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                });
            },
            // 修改状态
            moduleStateChange({id, state}) {
                updateTrainTypeState({
                    typeId: id,
                    state
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message({
                                type: 'success',
                                message: '板块状态已修改'
                            });
                        }
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../../commonsPC/styles/mixins";

    @include reset-global;

    .page {
        padding: 20px 50px;
        box-sizing: border-box;
    }
    .page-main {
        padding-top: 20px;
    }
    .module-list {
        overflow: auto;
        box-sizing: border-box;
    }
    .module-item {
        float: left;
        width: 24%;
        height: 120px;
        padding: 5px;
        margin: 30px 0;
        cursor: pointer;
        position: relative;
        &.module-item--grey {
            filter: grayscale(1);
            cursor: default;
        }
        & > * {
            @include middleIB;
        }
        .module-item__pic {
            @include wh(100px, 100px);
            @include cover-bg;
            margin-bottom: 5px;
            margin-right: 22px;
        }
        .module-item__info {
            width: 140px;
        }
        .module-item__name {
            text-align: left;
            @include nowrap;
            color: #878686;
            font-size: 22px;
        }
        .module-item__count {
            margin-top: 16px;
            font-size: 34px;
            color: #2ca8cb;
        }

        .fa {
            position: absolute;
            top: 0;
            display: none;
            cursor: pointer;
        }
        &:hover {
            .fa {
                display: block;
            }
        }
        .fa-edit {
            left: 2px;
            color: #87cefa;
        }
        .fa-close {
            left: 20px;
            color: #f08080;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/setting/moduleSetting/moduleList.vue